import { ModalsProvider } from '@mantine/modals';

import { captureException } from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet, createRootRoute } from '@tanstack/react-router';

import { AuthProvider } from '@/providers/AuthProvider/AuthProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (error) => captureException(error),
    },
  },
});

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ModalsProvider>
          <Outlet />
        </ModalsProvider>
      </AuthProvider>
    </QueryClientProvider>
  ),
});
